import {
  Box,
  Divider,
  Grid,
  makeStyles,
  ThemeProvider,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import CustomSelect from "../../../../../../../src/Components/CustomSelect";
import DataService from "../../../../../../Service";
import { fetchOraganization } from "./redux/OrganisationService";
import { Button } from "@material-ui/core";
import SaveAltIcon from "@material-ui/icons/SaveAlt";

import { commonTheme } from "../../../../../../commonTheme";
import useDownloads from "../../useDownloads";

const useStyles = makeStyles((theme) => ({
  small: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    margin: "0 auto",
  },
  headerClass: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

interface UserData {
  givenBy?: string;
  sessionScenario?: string;
  sortBy?: string;
  businessunit?: string;
  organisation_id?: string;
  other_stakeholders?: boolean;
}

const Organisaton: React.FC<any> = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [userData, setUserData] = useState<UserData>({
    givenBy: "All",
    sessionScenario: "All",
    sortBy: "All",
    businessunit: "All",
  });
  const [orgData, setOrgData] = useState([]);
  const organisationData = useSelector(
    (state: any) => state?.reportOrganisation
  );
  const feedbackData = useSelector((state: any) => state?.feedback);
  const onChangeItem = (selectedItemValue: any) => {
    setUserData({
      ...userData,
      [selectedItemValue.id]: selectedItemValue.value,
    });
  };
  const [dropdowns, setDropdowns] = useState({
    employees: [],
    session_scenario: [],
  });

  const sortByArray = [
    { id: 1, name: "All", value: "All" },
    { id: 2, name: "Newest", value: "Newest" },
    { id: 3, name: "Oldest", value: "Oldest" },
  ];
  const param: any = {
    ...(userData.givenBy && {
      employee_id: dropdowns?.employees?.find(
        (option: any) =>
          option.name?.toLowerCase() === userData?.givenBy?.toLowerCase()
        // @ts-ignore
      )?.id,
    }),
    ...(userData.sessionScenario && {
      session_scenario_id: dropdowns?.session_scenario?.find(
        (option: any) =>
          option.value?.toLowerCase() ===
          userData?.sessionScenario?.toLowerCase()
        // @ts-ignore
      )?.id,
    }),
    ...(userData.sortBy && {
      sort_by: sortByArray?.find(
        (option: any) =>
          option.value?.toLowerCase() === userData.sortBy?.toLowerCase()
      )?.name,
    }),
    ...(userData.businessunit && {
      organisation_id: orgData?.find(
        (option: any) =>
          option.organisation_name?.toLowerCase() ===
          userData.businessunit?.toLowerCase()
        // @ts-ignore
      )?.id,
    }),
    other_stakeholders: true,
  };

  useEffect(() => {
    dispatch(fetchOraganization(param));
  }, [
    userData.businessunit,
    userData.givenBy,
    userData.sessionScenario,
    userData.sortBy,
  ]);

  useEffect(() => {
    DataService.getData({}, "organisations").then((res: any) => {
      setOrgData(orgData.concat(res.organisations));
    });
    dispatch(fetchOraganization(param));
  }, []);

  useEffect(() => {
    let params: any = {};
    const localArr: any = orgData?.find(
      (option: any) =>
        option.organisation_name?.toLowerCase() ===
        userData?.businessunit?.toLowerCase()
    );
    let orgId = localArr ? localArr.id : "";
    if (orgId) {
      params.organisation_id = orgId;
    }
    DataService.getDirectData("feedbacks/listing_dropdowns", params)
      .then((res: any) => {
        setDropdowns(res);
        setUserData((prev) => {
          return { ...prev, givenBy: "All", sessionScenario: "All" };
        });
      })
      .catch((err) => {
        setDropdowns({
          employees: [],
          session_scenario: [],
        });
      });
  }, [userData?.businessunit]);

  // Downlading logic

  const getData = () => {
    console.log(param, "param");
    const localArr: any = orgData?.find(
      (option: any) =>
        option.organisation_name?.toLowerCase() ===
        userData?.businessunit?.toLowerCase()
    );
    var orgId = localArr ? localArr.id : "";
    if (orgId) {
      param.organisation_id = orgId;
    }
    return DataService.getData(param, "report_fetch_oraganization");
  };

  const fileName = `${
    userData.businessunit ? userData.businessunit : "All organisation"
  }_Feedback`;
  const columns: any = [
    { field: "feedback", title: "Feedback" },
    { field: "employee_name", title: "Given by" },
    { field: "session_scenario", title: "Session scenario" },
  ];
  console.log(userData, "userdata");
  const role = sessionStorage.getItem("role");
  const { downloading, downloadingOption, exportPDF, exportCsv, exportXLSX } =
    useDownloads({
      columns,
      getData,
      listKey: "collate_feedbacks",
      userData: {
        organisation: userData.businessunit,
      },
      role,
      fileName,
    });

  return (
    <Box py={3}>
      <ThemeProvider theme={commonTheme}>
        <Grid container direction="row">
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              spacing={2}
              className={classes.headerClass}
            >
              <Grid item xs={3}>
                <Typography variant="subtitle1" style={{ color: "#EF7000" }}>
                  <Box mb={1}>Organization</Box>
                </Typography>
                <CustomSelect
                  id="businessunit"
                  labelText="Select organization"
                  displayEmpty
                  variant="outlined"
                  itemArr={[
                    "All",
                    ...orgData.map((option: any) => option.organisation_name),
                  ]}
                  parentcall={onChangeItem}
                  defaultValue={userData.businessunit}
                />
              </Grid>
              <Grid item xs={3}>
                <Typography variant="subtitle1" style={{ color: "#EF7000" }}>
                  <Box mb={1}>Given by</Box>
                </Typography>
                <CustomSelect
                  id="givenBy"
                  labelText="Select given by"
                  displayEmpty
                  variant="outlined"
                  itemArr={[
                    "All",
                    ...dropdowns.employees?.map((el: any) => el.name),
                  ]}
                  parentcall={onChangeItem}
                  defaultValue={userData.givenBy}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle1" style={{ color: "#EF7000" }}>
                  <Box mb={1}>Session scenario</Box>
                </Typography>
                <CustomSelect
                  id="sessionScenario"
                  labelText="Select session scenario"
                  displayEmpty
                  variant="outlined"
                  itemArr={[
                    "All",
                    ...dropdowns.session_scenario?.map((el: any) => el.value),
                  ]}
                  parentcall={onChangeItem}
                  defaultValue={userData.sessionScenario}
                />
              </Grid>
              <Grid item xs={2}>
                <Typography variant="subtitle1" style={{ color: "#EF7000" }}>
                  <Box mb={1}>Sort by</Box>
                </Typography>
                <CustomSelect
                  id="sortBy"
                  labelText="Select sort by"
                  displayEmpty
                  variant="outlined"
                  itemArr={sortByArray.map((value: any) => value.value)}
                  parentcall={onChangeItem}
                  defaultValue={userData.sortBy}
                />
              </Grid>
              <Grid
                item
                xs={2}
                style={{
                  display: "flex",
                  gap: "0.5rem",
                  justifyContent: "flex-end",
                  alignItems: "flex-end",
                  height: "100%",
                  alignSelf: "flex-end",
                }}
              >
                <Button
                  color="primary"
                  disabled={!organisationData?.organisationData?.length}
                  style={{
                    textTransform: "inherit",
                    float: "right",
                    marginTop: "18px",
                    width: "170px",
                  }}
                  variant="contained"
                  onClick={exportXLSX}
                >
                  {downloading && downloadingOption === "xlsx" ? (
                    <CircularProgress
                      size={22}
                      style={{ marginRight: "5px", color: "white" }}
                    />
                  ) : (
                    <SaveAltIcon style={{ marginRight: "5px" }} />
                  )}
                  .xlsx
                </Button>

                <Button
                  color="primary"
                  disabled={!organisationData?.organisationData?.length}
                  style={{
                    textTransform: "inherit",
                    float: "right",
                    marginTop: "18px",
                    width: "170px",
                  }}
                  variant="contained"
                  onClick={exportCsv}
                >
                  {downloading && downloadingOption === "csv" ? (
                    <CircularProgress
                      size={22}
                      style={{ marginRight: "5px", color: "white" }}
                    />
                  ) : (
                    <SaveAltIcon style={{ marginRight: "5px" }} />
                  )}{" "}
                  .csv
                </Button>

                <Button
                  color="primary"
                  disabled={!organisationData?.organisationData?.length}
                  style={{
                    textTransform: "inherit",
                    float: "right",
                    marginTop: "18px",
                    width: "170px",
                  }}
                  variant="contained"
                  onClick={exportPDF}
                >
                  {downloading && downloadingOption === "pdf" ? (
                    <CircularProgress
                      size={22}
                      style={{ marginRight: "5px", color: "white" }}
                    />
                  ) : (
                    <SaveAltIcon style={{ marginRight: "5px" }} />
                  )}{" "}
                  .pdf
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          alignItems="center"
          style={{
            marginTop: 20,
            borderWidth: 1,
            borderColor: "#ddd",
            borderStyle: "solid",
            padding: 16,
          }}
        >
          <Grid item xs={6}>
            <Typography variant="h2" style={{ color: "#320032" }}>
              <Box fontWeight="fontWeightBold" color={"#077F83"}>
                Feedback
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h2" style={{ color: "#320032" }}>
              <Box fontWeight="fontWeightBold" color={"#077F83"}>
                Given by
              </Box>
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="h2" style={{ color: "#320032" }}>
              <Box fontWeight="fontWeightBold" color={"#077F83"}>
                Session scenario
              </Box>
            </Typography>
          </Grid>
        </Grid>

        <Box>
          {organisationData?.organisationData?.length ? (
            organisationData?.organisationData?.map((option: any) => {
              return (
                <>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    style={{
                      borderWidth: 1,
                      borderColor: "#ddd",
                      borderStyle: "solid",
                      padding: 16,
                    }}
                  >
                    <Grid item xs={6} style={{ paddingInline: 5 }}>
                      <Typography variant="h2" style={{ color: "black" }}>
                        <Box>{option?.feedback || "-"}</Box>
                      </Typography>
                    </Grid>

                    <Grid item xs={3} style={{ paddingInline: 5 }}>
                      <Typography variant="h2" style={{ color: "black" }}>
                        <Box>
                          {option?.employee_name
                            ?.map((item: any) => item)
                            .join(", ")}
                        </Box>
                      </Typography>
                    </Grid>
                    <Grid item xs={3} style={{ paddingInline: 5 }}>
                      <Typography variant="h2" style={{ color: "black" }}>
                        <Box>{option?.session_scenario || "-"}</Box>
                      </Typography>
                    </Grid>
                  </Grid>
                  <Divider />
                </>
              );
            })
          ) : (
            <Grid
              container
              direction="row"
              alignItems="center"
              style={{
                borderWidth: 1,
                borderColor: "#ddd",
                borderStyle: "solid",
                padding: 16,
              }}
            >
              <Grid item xs={3}>
                <Typography variant="h2" style={{ color: "black" }}>
                  <Box>{"Record not found"}</Box>
                </Typography>
              </Grid>
            </Grid>
          )}
        </Box>
      </ThemeProvider>
    </Box>
  );
};

export default Organisaton;
